/**
 * Разбор без ИИ: собирается из результатов расчёта.
 * Используется, пока ключ OpenAI не подключён, и как запасной вариант при ошибке.
 */

import { formatMoney, formatPercent } from '../format';

const buildSteps = (scenario, channels) => {
  const growing = scenario.levers.filter((lever) => lever.growth > 0);

  const steps = growing.map((lever) => ({
    title: lever.action,
    text:
      `Поднять «${lever.plainLabel.toLowerCase()}» на ${formatPercent(lever.growthPercent, 1)}: ` +
      `${lever.how.toLowerCase()}. Это ключевая часть сценария «${scenario.name.toLowerCase()}».`,
  }));

  if (channels && channels.channels.length) {
    const names = channels.channels.slice(0, 3).map((channel) => channel.name).join(', ');
    steps.push({
      title: 'Сосредоточиться на рабочих каналах',
      text: `Для вашей ниши в Казахстане это ${names}. Распылять бюджет на остальное смысла нет.`,
    });
  }

  return steps;
};

const buildRisks = (result, scenario) => {
  const risks = [];

  if (!scenario.closesTarget) {
    risks.push(
      `Этот сценарий закрывает ${formatPercent(scenario.targetCoverage)} нужного прироста. ` +
        'Остальное потребует либо больше времени, либо изменения самой модели бизнеса.',
    );
  }

  const cappedLevers = scenario.levers.filter((lever) => lever.atCap);
  if (cappedLevers.length) {
    risks.push(
      `Рычаги «${cappedLevers.map((lever) => lever.plainLabel.toLowerCase()).join('», «')}» ` +
        'выведены на предел по нише. Дальше их растить нереалистично.',
    );
  }

  if (!result.state.hasConversion) {
    risks.push(
      'Вы не указали число обращений, поэтому рычаг конверсии в расчёт не вошёл. ' +
        'Начните считать заявки — скорее всего, там есть заметный резерв.',
    );
  }

  if (result.adMetrics && result.adMetrics.adShare > 20) {
    risks.push(
      `На рекламу уходит ${formatPercent(result.adMetrics.adShare)} выручки. ` +
        'Это высокая доля — рост потока обращений будет дорогим.',
    );
  }

  if (scenario.timing.maxMonths >= 3) {
    risks.push(
      'Сценарий затрагивает частоту покупок — это самый медленный рычаг. ' +
        'Первые месяцы результата почти не будет видно, это нормально.',
    );
  }

  return risks;
};

export const buildFallbackReport = (result) => {
  const scenario = result.recommended || result.scenarios[0];

  if (!scenario) {
    return {
      fallback: true,
      summary:
        'Чтобы собрать разбор, поставьте цель выше текущей выручки — тогда появятся сценарии роста.',
      steps: [],
      risks: [],
    };
  }

  const summary =
    `Чтобы выйти на ${formatMoney(result.targetRevenue)} в месяц, вам подходит сценарий ` +
    `«${scenario.name.toLowerCase()}». Он даёт ${formatMoney(scenario.achievedRevenue)} ` +
    `за ${scenario.timing.label.toLowerCase()} и опирается на то, что у вас уже есть, ` +
    'а не на удвоение рекламного бюджета.';

  return {
    fallback: true,
    summary,
    steps: buildSteps(scenario, result.channels),
    risks: buildRisks(result, scenario),
  };
};
